"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Bootstrap_1 = require("./Bootstrap");
var game = Bootstrap_1.default.getInstance();
var url = new URL(window.location.href);
var baseUrl = url.origin;
game.setOnSubmitFn(window.setQABugScore);
// bug basico
game.addController({
    // opciones del insecto
    maxDelay: 600,
    minDelay: 400,
    imageSprite: "url(".concat(baseUrl, "/img/services/bug_1.png)"),
    frameHeight: 32,
    frameWidth: 32,
    maxBugs: 4,
    minBugs: 4,
    spriteSheetframes: {
        stop: {
            row: 1,
            columns: 6,
        },
        walk: {
            row: 2,
            columns: 6,
        },
        die: {
            row: 3,
            columns: 6,
        },
    }
});
// game.addController({
//   // opciones del gusano
// })
game.run();
